import axios from "axios";
import store from "@/store";
import router from "@/router";
import UserService from "@/plugins/apiServices/usersService";
import categorieService from "@/plugins/apiServices/categorieService";
import attributesService from "@/plugins/apiServices/attributesService";
import valuesService from "@/plugins/apiServices/valuesService";
import mappingsService from "@/plugins/apiServices/mappingsService";

export default {
  install(Vue) {
    const HttpServices = {
      users: UserService,
      categories: categorieService,
      attributes: attributesService,
      values: valuesService,
      mappings: mappingsService
    };

    const axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_MIRAKL_API_BASE_URL
    });

    /**
     * Returns all endpoints for thre required service
     * @param {string} serviceName
     * @return {Object} all endpoints for the required service
     */
    axiosInstance.service = serviceName => {
      if (HttpServices[serviceName])
        return HttpServices[serviceName](axiosInstance);
    };

    /**
     * sets interceptors for the gwz api axios instance
     * @return {undefined}
     */

    axiosInstance.interceptors.response.use(
      function(config) {
        const token = store.getters["users/getToken"];
        const refreshToken = store.getters["users/getRefreshToken"];
        if (token)
          axios
            .post(`${process.env.VUE_APP_MIRAKL_API_BASE_URL}/token_refresh`, {
              refresh_token: refreshToken
            })
            .then(res => {
              Vue.prototype.$gwzAuthCookies.set(res.data);
              const { token, refresh_token: refreshToken } = res.data;
              store.dispatch("users/setToken", token);
              store.dispatch("users/setRefreshToken", refreshToken);
            });
        return config;
      },
      function(error) {
        const IGNORED_PATHS = ["/login_check", "/token_refresh"];
        const isIgnored = IGNORED_PATHS.some(path =>
          error.config.url.includes(path)
        );
        const refreshToken = store.getters["users/getRefreshToken"];
        const statusCode = error.response ? error.response.status : -1;
        if (
          (statusCode === 401 || statusCode === 422) &&
          !isIgnored &&
          refreshToken
        ) {
          refresh(refreshToken);
          const config = { retryAttempts: 1, ...error.config };
          return axiosInstance(config);
        } else {
          if (typeof error.response.data.messages === "undefined") {
            return Promise.reject(error.response.data);
          } else if (
            typeof error.response.data.messages.errors === "undefined"
          ) {
            return Promise.reject(error.response.data.messages);
          }
        }
      }
    );

    axiosInstance.interceptors.request.use(
      config => {
        const token = store.getters["users/getToken"];
        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    let gwzApiService = axiosInstance;

    Vue.prototype.$gwzApi = gwzApiService;
    const refresh = refreshToken => {
      axios
        .post(`${process.env.VUE_APP_MIRAKL_API_BASE_URL}/token_refresh`, {
          refresh_token: refreshToken
        })
        .then(res => {
          Vue.prototype.$gwzAuthCookies.set(res.data);
          const { token, refresh_token: refreshToken } = res.data;
          store.dispatch("users/setToken", token);
          store.dispatch("users/setRefreshToken", refreshToken);
        })
        .catch(error => {
          store.dispatch("users/logout");
          const config = { retryAttempts: 1, ...error.config };
          router.push({ name: "Login" });
          return axios(config);
        });
    };
  }
};
